export const countries = [
    { value:"AF", text:"Afghanistan" },
    { value:"AL", text:"Albania" },
    { value:"DZ", text:"Algeria" },
    { value:"AS", text:"American Samoa" },
    { value:"AD", text:"Andorra" },
    { value:"AO", text:"Angola" },
    { value:"AI", text:"Anguilla" },
    { value:"AQ", text:"Antarctica" },
    { value:"AG", text:"Antigua and Barbuda" },
    { value:"AR", text:"Argentina" },
    { value:"AM", text:"Armenia" },
    { value:"AW", text:"Aruba" },
    { value:"AU", text:"Australia" },
    { value:"AT", text:"Austria" },
    { value:"AZ", text:"Azerbaijan" },
    { value:"BS", text:"Bahamas" },
    { value:"BH", text:"Bahrain" },
    { value:"BD", text:"Bangladesh" },
    { value:"BB", text:"Barbados" },
    { value:"BY", text:"Belarus" },
    { value:"BE", text:"Belgium" },
    { value:"BZ", text:"Belize" },
    { value:"BJ", text:"Benin" },
    { value:"BM", text:"Bermuda" },
    { value:"BT", text:"Bhutan" },
    { value:"BO", text:"Bolivia" },
    { value:"BA", text:"Bosnia and Herzegowina" },
    { value:"BW", text:"Botswana" },
    { value:"BV", text:"Bouvet Island" },
    { value:"BR", text:"Brazil" },
    { value:"IO", text:"British Indian Ocean Territory" },
    { value:"BN", text:"Brunei Darussalam" },
    { value:"BG", text:"Bulgaria" },
    { value:"BF", text:"Burkina Faso" },
    { value:"BI", text:"Burundi" },
    { value:"KH", text:"Cambodia" },
    { value:"CM", text:"Cameroon" },
    { value:"CA", text:"Canada" },
    { value:"CV", text:"Cape Verde" },
    { value:"KY", text:"Cayman Islands" },
    { value:"CF", text:"Central African Republic" },
    { value:"TD", text:"Chad" },
    { value:"CL", text:"Chile" },
    { value:"CN", text:"China" },
    { value:"CX", text:"Christmas Island" },
    { value:"CC", text:"Cocos (Keeling) Islands" },
    { value:"CO", text:"Colombia" },
    { value:"KM", text:"Comoros" },
    { value:"CG", text:"Congo" },
    { value:"CD", text:"Congo, the Democratic Republic of the" },
    { value:"CK", text:"Cook Islands" },
    { value:"CR", text:"Costa Rica" },
    { value:"CI", text:"Cote d'Ivoire" },
    { value:"HR", text:"Croatia (Hrvatska)" },
    { value:"CU", text:"Cuba" },
    { value:"CY", text:"Cyprus" },
    { value:"CZ", text:"Czech Republic" },
    { value:"DK", text:"Denmark" },
    { value:"DJ", text:"Djibouti" },
    { value:"DM", text:"Dominica" },
    { value:"DO", text:"Dominican Republic" },
    { value:"TP", text:"East Timor" },
    { value:"EC", text:"Ecuador" },
    { value:"EG", text:"Egypt" },
    { value:"SV", text:"El Salvador" },
    { value:"GQ", text:"Equatorial Guinea" },
    { value:"ER", text:"Eritrea" },
    { value:"EE", text:"Estonia" },
    { value:"ET", text:"Ethiopia" },
    { value:"FK", text:"Falkland Islands (Malvinas)" },
    { value:"FO", text:"Faroe Islands" },
    { value:"FJ", text:"Fiji" },
    { value:"FI", text:"Finland" },
    { value:"FR", text:"France" },
    { value:"FX", text:"France, Metropolitan" },
    { value:"GF", text:"French Guiana" },
    { value:"PF", text:"French Polynesia" },
    { value:"TF", text:"French Southern Territories" },
    { value:"GA", text:"Gabon" },
    { value:"GM", text:"Gambia" },
    { value:"GE", text:"Georgia" },
    { value:"DE", text:"Germany" },
    { value:"GH", text:"Ghana" },
    { value:"GI", text:"Gibraltar" },
    { value:"GR", text:"Greece" },
    { value:"GL", text:"Greenland" },
    { value:"GD", text:"Grenada" },
    { value:"GP", text:"Guadeloupe" },
    { value:"GU", text:"Guam" },
    { value:"GT", text:"Guatemala" },
    { value:"GN", text:"Guinea" },
    { value:"GW", text:"Guinea-Bissau" },
    { value:"GY", text:"Guyana" },
    { value:"HT", text:"Haiti" },
    { value:"HM", text:"Heard and Mc Donald Islands" },
    { value:"VA", text:"Holy See (Vatican City State)" },
    { value:"HN", text:"Honduras" },
    { value:"HK", text:"Hong Kong" },
    { value:"HU", text:"Hungary" },
    { value:"IS", text:"Iceland" },
    { value:"IN", text:"India" },
    { value:"ID", text:"Indonesia" },
    { value:"IR", text:"Iran (Islamic Republic of)" },
    { value:"IQ", text:"Iraq" },
    { value:"IE", text:"Ireland" },
    { value:"IL", text:"Israel" },
    { value:"IT", text:"Italy" },
    { value:"JM", text:"Jamaica" },
    { value:"JP", text:"Japan" },
    { value:"JO", text:"Jordan" },
    { value:"KZ", text:"Kazakhstan" },
    { value:"KE", text:"Kenya" },
    { value:"KI", text:"Kiribati" },
    { value:"KP", text:"Korea, Democratic People's Republic of" },
    { value:"KR", text:"Korea, Republic of" },
    { value:"KW", text:"Kuwait" },
    { value:"KG", text:"Kyrgyzstan" },
    { value:"LA", text:"Lao People's Democratic Republic" },
    { value:"LV", text:"Latvia" },
    { value:"LB", text:"Lebanon" },
    { value:"LS", text:"Lesotho" },
    { value:"LR", text:"Liberia" },
    { value:"LY", text:"Libyan Arab Jamahiriya" },
    { value:"LI", text:"Liechtenstein" },
    { value:"LT", text:"Lithuania" },
    { value:"LU", text:"Luxembourg" },
    { value:"MO", text:"Macau" },
    { value:"MK", text:"Macedonia, The Former Yugoslav Republic of" },
    { value:"MG", text:"Madagascar" },
    { value:"MW", text:"Malawi" },
    { value:"MY", text:"Malaysia" },
    { value:"MV", text:"Maldives" },
    { value:"ML", text:"Mali" },
    { value:"MT", text:"Malta" },
    { value:"MH", text:"Marshall Islands" },
    { value:"MQ", text:"Martinique" },
    { value:"MR", text:"Mauritania" },
    { value:"MU", text:"Mauritius" },
    { value:"YT", text:"Mayotte" },
    { value:"MX", text:"Mexico" },
    { value:"FM", text:"Micronesia, Federated States of" },
    { value:"MD", text:"Moldova, Republic of" },
    { value:"MC", text:"Monaco" },
    { value:"MN", text:"Mongolia" },
    { value:"MS", text:"Montserrat" },
    { value:"MA", text:"Morocco" },
    { value:"MZ", text:"Mozambique" },
    { value:"MM", text:"Myanmar" },
    { value:"NA", text:"Namibia" },
    { value:"NR", text:"Nauru" },
    { value:"NP", text:"Nepal" },
    { value:"NL", text:"Netherlands" },
    { value:"AN", text:"Netherlands Antilles" },
    { value:"NC", text:"New Caledonia" },
    { value:"NZ", text:"New Zealand" },
    { value:"NI", text:"Nicaragua" },
    { value:"NE", text:"Niger" },
    { value:"NG", text:"Nigeria" },
    { value:"NU", text:"Niue" },
    { value:"NF", text:"Norfolk Island" },
    { value:"MP", text:"Northern Mariana Islands" },
    { value:"NO", text:"Norway" },
    { value:"OM", text:"Oman" },
    { value:"PK", text:"Pakistan" },
    { value:"PW", text:"Palau" },
    { value:"PA", text:"Panama" },
    { value:"PG", text:"Papua New Guinea" },
    { value:"PY", text:"Paraguay" },
    { value:"PE", text:"Peru" },
    { value:"PH", text:"Philippines" },
    { value:"PN", text:"Pitcairn" },
    { value:"PL", text:"Poland" },
    { value:"PT", text:"Portugal" },
    { value:"PR", text:"Puerto Rico" },
    { value:"QA", text:"Qatar" },
    { value:"RE", text:"Reunion" },
    { value:"RO", text:"Romania" },
    { value:"RU", text:"Russian Federation" },
    { value:"RW", text:"Rwanda" },
    { value:"KN", text:"Saint Kitts and Nevis" },
    { value:"LC", text:"Saint LUCIA" },
    { value:"VC", text:"Saint Vincent and the Grenadines" },
    { value:"WS", text:"Samoa" },
    { value:"SM", text:"San Marino" },
    { value:"ST", text:"Sao Tome and Principe" },
    { value:"SA", text:"Saudi Arabia" },
    { value:"SN", text:"Senegal" },
    { value:"SC", text:"Seychelles" },
    { value:"SL", text:"Sierra Leone" },
    { value:"SG", text:"Singapore" },
    { value:"SK", text:"Slovakia (Slovak Republic)" },
    { value:"SI", text:"Slovenia" },
    { value:"SB", text:"Solomon Islands" },
    { value:"SO", text:"Somalia" },
    { value:"ZA", text:"South Africa" },
    { value:"GS", text:"South Georgia and the South Sandwich Islands" },
    { value:"ES", text:"Spain" },
    { value:"LK", text:"Sri Lanka" },
    { value:"SH", text:"St. Helena" },
    { value:"PM", text:"St. Pierre and Miquelon" },
    { value:"SD", text:"Sudan" },
    { value:"SR", text:"Suriname" },
    { value:"SJ", text:"Svalbard and Jan Mayen Islands" },
    { value:"SZ", text:"Swaziland" },
    { value:"SE", text:"Sweden" },
    { value:"CH", text:"Switzerland" },
    { value:"SY", text:"Syrian Arab Republic" },
    { value:"TW", text:"Taiwan, Province of China" },
    { value:"TJ", text:"Tajikistan" },
    { value:"TZ", text:"Tanzania, United Republic of" },
    { value:"TH", text:"Thailand" },
    { value:"TG", text:"Togo" },
    { value:"TK", text:"Tokelau" },
    { value:"TO", text:"Tonga" },
    { value:"TT", text:"Trinidad and Tobago" },
    { value:"TN", text:"Tunisia" },
    { value:"TR", text:"Turkey" },
    { value:"TM", text:"Turkmenistan" },
    { value:"TC", text:"Turks and Caicos Islands" },
    { value:"TV", text:"Tuvalu" },
    { value:"UG", text:"Uganda" },
    { value:"UA", text:"Ukraine" },
    { value:"AE", text:"United Arab Emirates" },
    { value:"GB", text:"United Kingdom" },
    { value:"US", text:"United States" },
    { value:"UM", text:"United States Minor Outlying Islands" },
    { value:"UY", text:"Uruguay" },
    { value:"UZ", text:"Uzbekistan" },
    { value:"VU", text:"Vanuatu" },
    { value:"VE", text:"Venezuela" },
    { value:"VN", text:"Viet Nam" },
    { value:"VG", text:"Virgin Islands (British)" },
    { value:"VI", text:"Virgin Islands (U.S.)" },
    { value:"WF", text:"Wallis and Futuna Islands" },
    { value:"EH", text:"Western Sahara" },
    { value:"YE", text:"Yemen" },
    { value:"YU", text:"Yugoslavia" },
    { value:"ZM", text:"Zambia" },
    { value:"ZW", text:"Zimbabwe" }
];

export const countriesTrialPage = [
    { value:"Afghanistan", text:"Afghanistan" },
    { value:"Albania", text:"Albania" },
    { value:"Algeria", text:"Algeria" },
    { value:"American Samoa", text:"American Samoa" },
    { value:"Andorra", text:"Andorra" },
    { value:"Angola", text:"Angola" },
    { value:"Anguilla", text:"Anguilla" },
    { value:"Antarctica", text:"Antarctica" },
    { value:"Antigua and Barbuda", text:"Antigua and Barbuda" },
    { value:"Argentina", text:"Argentina" },
    { value:"Armenia", text:"Armenia" },
    { value:"Aruba", text:"Aruba" },
    { value:"Australia", text:"Australia" },
    { value:"Austria", text:"Austria" },
    { value:"Azerbaijan", text:"Azerbaijan" },
    { value:"Bahamas", text:"Bahamas" },
    { value:"Bahrain", text:"Bahrain" },
    { value:"Bangladesh", text:"Bangladesh" },
    { value:"Barbados", text:"Barbados" },
    { value:"Belarus", text:"Belarus" },
    { value:"Belgium", text:"Belgium" },
    { value:"Belize", text:"Belize" },
    { value:"Benin", text:"Benin" },
    { value:"Bermuda", text:"Bermuda" },
    { value:"Bhutan", text:"Bhutan" },
    { value:"Bolivia", text:"Bolivia" },
    { value:"Bosnia and Herzegowina", text:"Bosnia and Herzegowina" },
    { value:"Botswana", text:"Botswana" },
    { value:"Bouvet Island", text:"Bouvet Island" },
    { value:"Brazil", text:"Brazil" },
    { value:"British Indian Ocean Territory", text:"British Indian Ocean Territory" },
    { value:"Brunei Darussalam", text:"Brunei Darussalam" },
    { value:"Bulgaria", text:"Bulgaria" },
    { value:"Burkina Faso", text:"Burkina Faso" },
    { value:"Burundi", text:"Burundi" },
    { value:"Cambodia", text:"Cambodia" },
    { value:"Cameroon", text:"Cameroon" },
    { value:"Canada", text:"Canada" },
    { value:"Cape Verde", text:"Cape Verde" },
    { value:"Cayman Islands", text:"Cayman Islands" },
    { value:"Central African Republic", text:"Central African Republic" },
    { value:"Chad", text:"Chad" },
    { value:"Chile", text:"Chile" },
    { value:"China", text:"China" },
    { value:"Christmas Island", text:"Christmas Island" },
    { value:"Cocos (Keeling) Islands", text:"Cocos (Keeling) Islands" },
    { value:"Colombia", text:"Colombia" },
    { value:"Comoros", text:"Comoros" },
    { value:"Congo", text:"Congo" },
    { value:"Congo, the Democratic Republic of the", text:"Congo, the Democratic Republic of the" },
    { value:"Cook Islands", text:"Cook Islands" },
    { value:"Costa Rica", text:"Costa Rica" },
    { value:"Cote d'Ivoire", text:"Cote d'Ivoire" },
    { value:"Croatia (Hrvatska)", text:"Croatia (Hrvatska)" },
    { value:"Cuba", text:"Cuba" },
    { value:"Cyprus", text:"Cyprus" },
    { value:"Czech Republic", text:"Czech Republic" },
    { value:"Denmark", text:"Denmark" },
    { value:"Djibouti", text:"Djibouti" },
    { value:"Dominica", text:"Dominica" },
    { value:"Dominican Republic", text:"Dominican Republic" },
    { value:"East Timor", text:"East Timor" },
    { value:"Ecuador", text:"Ecuador" },
    { value:"Egypt", text:"Egypt" },
    { value:"El Salvador", text:"El Salvador" },
    { value:"Equatorial Guinea", text:"Equatorial Guinea" },
    { value:"Eritrea", text:"Eritrea" },
    { value:"Estonia", text:"Estonia" },
    { value:"Ethiopia", text:"Ethiopia" },
    { value:"Falkland Islands (Malvinas)", text:"Falkland Islands (Malvinas)" },
    { value:"Faroe Islands", text:"Faroe Islands" },
    { value:"Fiji", text:"Fiji" },
    { value:"Finland", text:"Finland" },
    { value:"France", text:"France" },
    { value:"France, Metropolitan", text:"France, Metropolitan" },
    { value:"French Guiana", text:"French Guiana" },
    { value:"French Polynesia", text:"French Polynesia" },
    { value:"French Southern Territories", text:"French Southern Territories" },
    { value:"Gabon", text:"Gabon" },
    { value:"Gambia", text:"Gambia" },
    { value:"Georgia", text:"Georgia" },
    { value:"Germany", text:"Germany" },
    { value:"Ghana", text:"Ghana" },
    { value:"Gibraltar", text:"Gibraltar" },
    { value:"Greece", text:"Greece" },
    { value:"Greenland", text:"Greenland" },
    { value:"Grenada", text:"Grenada" },
    { value:"Guadeloupe", text:"Guadeloupe" },
    { value:"Guam", text:"Guam" },
    { value:"Guatemala", text:"Guatemala" },
    { value:"Guinea", text:"Guinea" },
    { value:"Guinea-Bissau", text:"Guinea-Bissau" },
    { value:"Guyana", text:"Guyana" },
    { value:"Haiti", text:"Haiti" },
    { value:"Heard and Mc Donald Islands", text:"Heard and Mc Donald Islands" },
    { value:"Holy See (Vatican City State)", text:"Holy See (Vatican City State)" },
    { value:"Honduras", text:"Honduras" },
    { value:"Hong Kong", text:"Hong Kong" },
    { value:"Hungary", text:"Hungary" },
    { value:"Iceland", text:"Iceland" },
    { value:"India", text:"India" },
    { value:"Indonesia", text:"Indonesia" },
    { value:"Iran (Islamic Republic of)", text:"Iran (Islamic Republic of)" },
    { value:"Iraq", text:"Iraq" },
    { value:"Ireland", text:"Ireland" },
    { value:"Israel", text:"Israel" },
    { value:"Italy", text:"Italy" },
    { value:"Jamaica", text:"Jamaica" },
    { value:"Japan", text:"Japan" },
    { value:"Jordan", text:"Jordan" },
    { value:"Kazakhstan", text:"Kazakhstan" },
    { value:"Kenya", text:"Kenya" },
    { value:"Kiribati", text:"Kiribati" },
    { value:"Korea, Democratic People's Republic of", text:"Korea, Democratic People's Republic of" },
    { value:"Korea, Republic of", text:"Korea, Republic of" },
    { value:"Kuwait", text:"Kuwait" },
    { value:"Kyrgyzstan", text:"Kyrgyzstan" },
    { value:"Lao People's Democratic Republic", text:"Lao People's Democratic Republic" },
    { value:"Latvia", text:"Latvia" },
    { value:"Lebanon", text:"Lebanon" },
    { value:"Lesotho", text:"Lesotho" },
    { value:"Liberia", text:"Liberia" },
    { value:"Libyan Arab Jamahiriya", text:"Libyan Arab Jamahiriya" },
    { value:"Liechtenstein", text:"Liechtenstein" },
    { value:"Lithuania", text:"Lithuania" },
    { value:"Luxembourg", text:"Luxembourg" },
    { value:"Macau", text:"Macau" },
    { value:"Macedonia, The Former Yugoslav Republic of", text:"Macedonia, The Former Yugoslav Republic of" },
    { value:"Madagascar", text:"Madagascar" },
    { value:"Malawi", text:"Malawi" },
    { value:"Malaysia", text:"Malaysia" },
    { value:"Maldives", text:"Maldives" },
    { value:"Mali", text:"Mali" },
    { value:"Malta", text:"Malta" },
    { value:"Marshall Islands", text:"Marshall Islands" },
    { value:"Martinique", text:"Martinique" },
    { value:"Mauritania", text:"Mauritania" },
    { value:"Mauritius", text:"Mauritius" },
    { value:"Mayotte", text:"Mayotte" },
    { value:"Mexico", text:"Mexico" },
    { value:"Micronesia, Federated States of", text:"Micronesia, Federated States of" },
    { value:"Moldova, Republic of", text:"Moldova, Republic of" },
    { value:"Monaco", text:"Monaco" },
    { value:"Mongolia", text:"Mongolia" },
    { value:"Montserrat", text:"Montserrat" },
    { value:"Morocco", text:"Morocco" },
    { value:"Mozambique", text:"Mozambique" },
    { value:"Myanmar", text:"Myanmar" },
    { value:"Namibia", text:"Namibia" },
    { value:"Nauru", text:"Nauru" },
    { value:"Nepal", text:"Nepal" },
    { value:"Netherlands", text:"Netherlands" },
    { value:"Netherlands Antilles", text:"Netherlands Antilles" },
    { value:"New Caledonia", text:"New Caledonia" },
    { value:"New Zealand", text:"New Zealand" },
    { value:"Nicaragua", text:"Nicaragua" },
    { value:"Niger", text:"Niger" },
    { value:"Nigeria", text:"Nigeria" },
    { value:"Niue", text:"Niue" },
    { value:"Norfolk Island", text:"Norfolk Island" },
    { value:"Northern Mariana Islands", text:"Northern Mariana Islands" },
    { value:"Norway", text:"Norway" },
    { value:"Oman", text:"Oman" },
    { value:"Pakistan", text:"Pakistan" },
    { value:"Palau", text:"Palau" },
    { value:"Panama", text:"Panama" },
    { value:"Papua New Guinea", text:"Papua New Guinea" },
    { value:"Paraguay", text:"Paraguay" },
    { value:"Peru", text:"Peru" },
    { value:"Philippines", text:"Philippines" },
    { value:"Pitcairn", text:"Pitcairn" },
    { value:"Poland", text:"Poland" },
    { value:"Portugal", text:"Portugal" },
    { value:"Puerto Rico", text:"Puerto Rico" },
    { value:"Qatar", text:"Qatar" },
    { value:"Reunion", text:"Reunion" },
    { value:"Romania", text:"Romania" },
    { value:"Russian Federation", text:"Russian Federation" },
    { value:"Rwanda", text:"Rwanda" },
    { value:"Saint Kitts and Nevis", text:"Saint Kitts and Nevis" },
    { value:"Saint LUCIA", text:"Saint LUCIA" },
    { value:"Saint Vincent and the Grenadines", text:"Saint Vincent and the Grenadines" },
    { value:"Samoa", text:"Samoa" },
    { value:"San Marino", text:"San Marino" },
    { value:"Sao Tome and Principe", text:"Sao Tome and Principe" },
    { value:"Saudi Arabia", text:"Saudi Arabia" },
    { value:"Senegal", text:"Senegal" },
    { value:"Seychelles", text:"Seychelles" },
    { value:"Sierra Leone", text:"Sierra Leone" },
    { value:"Singapore", text:"Singapore" },
    { value:"Slovakia (Slovak Republic)", text:"Slovakia (Slovak Republic)" },
    { value:"Slovenia", text:"Slovenia" },
    { value:"Solomon Islands", text:"Solomon Islands" },
    { value:"Somalia", text:"Somalia" },
    { value:"South Africa", text:"South Africa" },
    { value:"South Georgia and the South Sandwich Islands", text:"South Georgia and the South Sandwich Islands" },
    { value:"Spain", text:"Spain" },
    { value:"Sri Lanka", text:"Sri Lanka" },
    { value:"St. Helena", text:"St. Helena" },
    { value:"St. Pierre and Miquelon", text:"St. Pierre and Miquelon" },
    { value:"Sudan", text:"Sudan" },
    { value:"Suriname", text:"Suriname" },
    { value:"Svalbard and Jan Mayen Islands", text:"Svalbard and Jan Mayen Islands" },
    { value:"Swaziland", text:"Swaziland" },
    { value:"Sweden", text:"Sweden" },
    { value:"Switzerland", text:"Switzerland" },
    { value:"Syrian Arab Republic", text:"Syrian Arab Republic" },
    { value:"Taiwan, Province of China", text:"Taiwan, Province of China" },
    { value:"Tajikistan", text:"Tajikistan" },
    { value:"Tanzania, United Republic of", text:"Tanzania, United Republic of" },
    { value:"Thailand", text:"Thailand" },
    { value:"Togo", text:"Togo" },
    { value:"Tokelau", text:"Tokelau" },
    { value:"Tonga", text:"Tonga" },
    { value:"Trinidad and Tobago", text:"Trinidad and Tobago" },
    { value:"Tunisia", text:"Tunisia" },
    { value:"Turkey", text:"Turkey" },
    { value:"Turkmenistan", text:"Turkmenistan" },
    { value:"Turks and Caicos Islands", text:"Turks and Caicos Islands" },
    { value:"Tuvalu", text:"Tuvalu" },
    { value:"Uganda", text:"Uganda" },
    { value:"Ukraine", text:"Ukraine" },
    { value:"United Arab Emirates", text:"United Arab Emirates" },
    { value:"United Kingdom", text:"United Kingdom" },
    { value:"United States", text:"United States" },
    { value:"United States Minor Outlying Islands", text:"United States Minor Outlying Islands" },
    { value:"Uruguay", text:"Uruguay" },
    { value:"Uzbekistan", text:"Uzbekistan" },
    { value:"Vanuatu", text:"Vanuatu" },
    { value:"Venezuela", text:"Venezuela" },
    { value:"Viet Nam", text:"Viet Nam" },
    { value:"Virgin Islands (British)", text:"Virgin Islands (British)" },
    { value:"Virgin Islands (U.S.)", text:"Virgin Islands (U.S.)" },
    { value:"Wallis and Futuna Islands", text:"Wallis and Futuna Islands" },
    { value:"Western Sahara", text:"Western Sahara" },
    { value:"Yemen", text:"Yemen" },
    { value:"Yugoslavia", text:"Yugoslavia" },
    { value:"Zambia", text:"Zambia" },
    { value:"Zimbabwe", text:"Zimbabwe" }
];

export const eurozone_countries = [
    { value: "AT", text: "Austria", vatRate: 20 },
    { value: "BE", text: "Belgium", vatRate: 21 },
    { value: "BG", text: "Bulgaria", vatRate: 20 },
    { value: "CY", text: "Cyprus", vatRate: 19 },
    { value: "CZ", text: "Czech Republic", vatRate: 21 },
    { value: "DE", text: "Germany", vatRate: 19 },
    { value: "DK", text: "Denmark", vatRate: 25 },
    { value: "EE", text: "Estonia", vatRate: 22 },
    { value: "ES", text: "Spain", vatRate: 21 },
    { value: "FI", text: "Finland", vatRate: 24 },
    { value: "FR", text: "France", vatRate: 20 },
    { value: "GR", text: "Greece", vatRate: 24 },
    { value: "HR", text: "Croatia", vatRate: 25 },
    { value: "HU", text: "Hungary", vatRate: 27 },
    { value: "IE", text: "Ireland", vatRate: 23 },
    { value: "IT", text: "Italy", vatRate: 22 },
    { value: "LT", text: "Lithuania", vatRate: 21 },
    { value: "LU", text: "Luxembourg", vatRate: 17 },
    { value: "LV", text: "Latvia", vatRate: 21 },
    { value: "MT", text: "Malta", vatRate: 18 },
    { value: "NL", text: "Netherlands", vatRate: 21 },
    { value: "PL", text: "Poland", vatRate: 23 },
    { value: "PT", text: "Portugal", vatRate: 23 },
    { value: "RO", text: "Romania", vatRate: 19 },
    { value: "SE", text: "Sweden", vatRate: 25 },
    { value: "SI", text: "Slovenia", vatRate: 22 },
    { value: "SK", text: "Slovakia", vatRate: 20 },
];